var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(-1130 -1388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(1130 1388)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.004
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "image_2_",
    "data-name": "image (2)",
    transform: "translate(1134 1392.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M8.333,162.466a4.992,4.992,0,0,1-4.723-3.4l-.047-.153a4.867,4.867,0,0,1-.231-1.445v-9.091L.1,159.173a3.028,3.028,0,0,0,2.123,3.673l20.618,5.522a3.059,3.059,0,0,0,.768.1,2.973,2.973,0,0,0,2.881-2.18l1.2-3.82Zm0,0",
    transform: "translate(0 -138.64)",
    fill: "#438afe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M151.987,69.826a2.667,2.667,0,1,0-2.667-2.667A2.669,2.669,0,0,0,151.987,69.826Zm0,0",
    transform: "translate(-139.987 -60)",
    fill: "#438afe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M108.654.492h-20A3.338,3.338,0,0,0,85.32,3.826V18.493a3.338,3.338,0,0,0,3.333,3.334h20a3.338,3.338,0,0,0,3.334-3.334V3.826A3.338,3.338,0,0,0,108.654.492Zm-20,2.667h20a.667.667,0,0,1,.667.667v9.466l-4.212-4.915a2.388,2.388,0,0,0-1.788-.82,2.331,2.331,0,0,0-1.781.841l-4.952,5.944-1.613-1.609a2.34,2.34,0,0,0-3.307,0l-3.68,3.679V3.826A.667.667,0,0,1,88.654,3.159Zm0,0",
    transform: "translate(-79.987 0)",
    fill: "#438afe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.988e34aa096060565c1086cbc1d7d00a.svg";
export { ForwardRef as ReactComponent };